import {
  BasketColumnKeys,
  BasketGroupSortType,
} from 'graphql-api/baskets-api-interfaces';

// sonar gives false positive error, const cast IS useful for SortableColumns type
/* tslint:disable:no-useless-cast */
export const SORTABLE_COLUMNS = [
  BasketColumnKeys.DeliveryDate,
  BasketColumnKeys.Markup,
  BasketColumnKeys.Wsp,
  BasketColumnKeys.Rrp,
  BasketColumnKeys.Quantity,
  BasketColumnKeys.Value,
  BasketColumnKeys.ValueNet,
  BasketColumnKeys.ValueRrp,
  BasketColumnKeys.Net,
  BasketColumnKeys.CreatedDate,
  BasketColumnKeys.ProductId,
  BasketColumnKeys.Gender,
] as const;
/* tslint:enable:no-useless-cast */

export type SortableColumns = typeof SORTABLE_COLUMNS[number];

export type ColKeysToSorting = {
  [key in SortableColumns]: BasketGroupSortType;
};

export type SortingToColKeys = {
  [key in BasketGroupSortType]?: SortableColumns;
};
